export const DEFECT_TYPES = [
  'Short shot',
  'Flash',
  'Sink mark',
  'Warp',
  'Burn mark',
  'Weld line',
  'Colour issue',
  'Contamination',
  'Dimensional',
  'Surface finish',
  'Other',
];
